module.exports = __webpack_public_path__ + "img/10.e2bed33c.png";